import { useRef } from 'react'
import { observer } from 'mobx-react-lite'
import { Avatar, type IDropdownItem, Typography } from 'shared/ui'
import { SelectField } from 'shared/ui/Select/SelectField/SelectField'
import { useElementWidth } from 'shared/hooks/useElementWidth'
import styles from './styles.module.scss'

export type IManualAssignmentUserSelectProps = {
  setValue: (value: number) => void
  value: number | null
  items: IDropdownItem[]
  search: string
  onSearch: (value: string) => void
  selectedItem?: IDropdownItem
}

export const ManualAssignmentUserSelect = observer(
  ({
    setValue,
    value,
    items,
    search,
    onSearch,
    selectedItem,
  }: IManualAssignmentUserSelectProps) => {
    const wrapperRef = useRef<HTMLDivElement>(null)
    const dropdownWidth = useElementWidth(wrapperRef)

    const handleDropdownOpen = (isOpen: boolean) => {
      if (isOpen) {
        onSearch('')
      }
    }

    return (
      <div ref={wrapperRef} className={styles.wrapper}>
        <SelectField
          setValue={setValue}
          value={value}
          item={selectedItem}
          items={items}
          btnProps={{
            size: 'medium',
            style: {
              height: '40px',
              paddingRight: '8px',
            },
            text: (
              <Typography ariaLabel={'name'} className={styles.selectLine}>
                <Avatar
                  size={16}
                  info={selectedItem?.avatarProps?.info || { icon: 'personFilled' }}
                />
                <span className={styles.selectValue}>{selectedItem?.label}</span>
              </Typography>
            ),
          }}
          search={search}
          onSearch={onSearch}
          dropdownProps={{
            width: dropdownWidth,
            onChangeOpen: handleDropdownOpen,
            propsDropdownList: {
              notFoundText: 'No results found',
            },
            PopperProps: {
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, -42],
                  },
                },
              ],
            },
          }}
        />
      </div>
    )
  }
)
